var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drawer',{attrs:{"title":_vm.titleDrawer},on:{"updateClose":_vm.onClose,"updateSave":_vm.onSave}},[_vm._v(" StatementNewItem ")])
}
var staticRenderFns = []

export { render, staticRenderFns }